import React from 'react';
import * as _ from 'lodash';
import {
  isNotUndefinedAll,
  isFunctionAll,
  isArrayAll,
} from '../../../utilities/parts';

import { MultiComboBoxBlock } from '../CommonDropDown';
import { Description } from '../../Description';
import SafetyDocItemIcon from '../../../components/SafetyDocItemIcon';

import AttachDocument from '../../forms/AttachDocument';
import {
  FormList,
  FormListSubHeader,
  CcusTranscriptionFormBlock,
  FormListItem,
  FormElement,
} from '../../CommonFormComponents';
import { CcusTitleBlock, CcusBlockComponent } from '../../CcusFormComponent';
import LicenseRegisterBlock from '../LicenseRegisterBlock';

/**
 * 作業員編集 画面 > 職種・免許・資格
 */
const JobLicenseForm = ({
  events,
  formValues,
  messages,
  disabledAll,
  comboBoxList,
  attachDocumentCodes_License,
  attachDocuments_License,
  ccusDescription,
  isCcusJigyousyaDeleted,
}) => {
  if (
    !isNotUndefinedAll(events, formValues, messages, disabledAll, comboBoxList)
  ) {
    throw new Error('JobLicenseForm.jsx function call');
  }
  if (!isArrayAll(attachDocumentCodes_License, attachDocuments_License)) {
    throw new Error('JobLicenseForm.jsx function call');
  }
  if (
    !isFunctionAll(
      events.setCCUSValuesJobLicense,
      events.addNewBlock,
      events.inputValueSearch,
      events.deleteValue,
      events.setJobValues,
      events.uploadFile,
      events.download,
      events.deleteFile
    )
  ) {
    throw new Error('JobLicenseForm.jsx function call');
  }

  const getCcusBlockElement = (formValues, name) => {
    const result = [];
    _.map(formValues[`ccus_${name}`], value => {
      switch (name) {
        case 'worker_core_technicians':
          result.push(
            `${value.core_technician_name} : ${value.core_technician_take_date}`
          );
          break;
        case 'worker_engineer_licenses':
          result.push(
            `${value.engineer_licenses_name} : ${value.engineer_licenses_take_date}`
          );
          break;
        case 'worker_jobs':
          result.push(value.at_time_job_name);
          break;
        case 'worker_licenses':
          result.push(`${value.licenses_name} : ${value.licenses_take_date}`);
          break;
      }
    });
    return result;
  };

  const getErrorMessage = (messages, target, searchKey) => {
    const targetSize = Object.keys(target).length;
    let errorMessage;
    for (let i = 0; i < targetSize; i++) {
      errorMessage = _.get(messages, `[${i}].${searchKey}`);
    }
    return errorMessage;
  };

  const WORKER_JOBS = {
    searchKey: 'at_time_job_name',
    codeKey: 'ccus_job_code_s',
    targetKey: 'worker_jobs',
    blockKey: 'jobLicense',
    codeKeyL: 'ccus_job_code_l',
  };
  // BLDE_V2-50226 CCUS事業者IDは削除された場合に、転記情報は表示されない
  const TitleElement = ({ title, name, noMarginTop }) => (
    <React.Fragment>
      <FormListSubHeader
        title={title}
        ccusComponent={
          !disabledAll &&
          name &&
          _.size(formValues[`ccus_${name}`]) !== 0 &&
          !isCcusJigyousyaDeleted && (
            <CcusTitleBlock
              onClick={e => {
                e.preventDefault();
                events.showCcusInfoTranscriptionAgreementDialog(name);
              }}
            />
          )
        }
        noMarginTop={noMarginTop}
      />
      {!disabledAll &&
        name &&
        _.size(formValues[`ccus_${name}`]) !== 0 &&
        !isCcusJigyousyaDeleted && (
          <CcusTranscriptionFormBlock
            ccusComponent={
              <CcusBlockComponent
                components={getCcusBlockElement(formValues, name)}
              />
            }
          />
        )}
    </React.Fragment>
  );

  const WorkerJobsComment = ({ children }) => (
    <div className='WorkerJobsComment'>
      {_.isString(children) ? (
        <p className='WorkerJobsComment__contents'>{children}</p>
      ) : (
        <div className='WorkerJobsComment__contents'>{children}</div>
      )}
    </div>
  );

  return (
    <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
      {ccusDescription}
      <FormList>
        {!disabledAll && (
          <div
            style={{
              maxWidth: '960px',
              marginBottom: '24px',
            }}
          >
            <Description type='primary'>
              「労務安全基本情報」タブ内の教育欄と「受講表彰履歴」タブにも関連した入力項目があります。
            </Description>
          </div>
        )}

        <TitleElement title='職種' name='worker_jobs' noMarginTop={true} />
        <FormListItem
          label='職種名'
          safetyDocItem={<SafetyDocItemIcon isFormListDefault={true} />}
        >
          <FormElement
            validate={getErrorMessage(
              _.get(messages, 'jobLicense.worker_jobs'),
              formValues.worker_jobs,
              WORKER_JOBS.searchKey
            )}
          >
            <div className='form-container'>
              <MultiComboBoxBlock
                targetValues={formValues.worker_jobs}
                events={events}
                disabledAll={disabledAll}
                comboBoxList={_.map(comboBoxList.workerJobs, job => {
                  job[
                    'at_time_job_name'
                  ] = `${job.at_time_large_job_name} - ${job.at_time_small_job_name}`;
                  return job;
                })}
                keyParams={WORKER_JOBS}
              />
              {!disabledAll && (
                <div
                  className={
                    _.isEmpty(formValues.worker_jobs)
                      ? ''
                      : 'form-container__item'
                  }
                >
                  <button
                    className='btn--sub'
                    onClick={() => {
                      events.addNewBlock('worker_jobs', {
                        id: null,
                        ccus_job_code_s: '01',
                        at_time_job_name: '',
                        ccus_job_code_l: '55',
                      });
                    }}
                  >
                    追加する
                  </button>
                </div>
              )}
            </div>
          </FormElement>
        </FormListItem>

        {/* BLDE_V2-31062 CCUSへ連携する「職種」「立場」は現場体制から登録するように注意点を表示する */}
        <WorkerJobsComment>
          CCUS連携に必要な「職種・立場」は現場体制（施工体系図）から設定してください。
        </WorkerJobsComment>

        <TitleElement title='基幹技能者' name='worker_core_technicians' />
        <LicenseRegisterBlock
          valueArray={formValues.worker_core_technicians}
          keyObject={{
            searchKey: 'core_technician_name',
            codeKey: 'core_technician_code',
            targetKey: 'worker_core_technicians',
            takeDateKey: 'core_technician_take_date',
            expireDateKey: 'core_technician_expire_date',
          }}
          comboBoxObject={{
            isShow: true,
            comboBoxList: comboBoxList.workerCoreTechnicians,
            comboBoxTitle: '名称',
          }}
          takeDateObject={{
            isShow: true,
            takeDateTitle: '取得年月日',
          }}
          expireDateObject={{
            isShow: true,
            isShowInfo: true,
            expireDateTitle: '有効期限年月日',
          }}
          validPeriodObject={{
            isShow: true,
            validPeriodTitle: '有効期間',
          }}
          attachDocumentObject={{
            isShow: true,
            documentCodes: attachDocumentCodes_License,
            itemName: '',
            indexId: '基幹技能者',
            labelDocument: '証明書・免許証',
            keyName: 'worker_core_technicians',
          }}
          messageArray={_.get(messages, 'jobLicense.worker_core_technicians')}
          disabled={disabledAll}
          safetyDocItem={true}
          events={events}
        />
        {!disabledAll && (
          <FormListItem className='form-list__item form-list__item--btn'>
            <button
              className='btn--sub'
              onClick={() => {
                events.addNewBlock('worker_core_technicians', {
                  id: null,
                  core_technician_code: '0',
                  core_technician_name: '',
                  core_technician_take_date: null,
                  core_technician_expire_date: null,
                  worker_documents: [],
                  validPeriodObject: {},
                  showExpireDate: true,
                  warningMessage: null,
                });
              }}
            >
              追加する
            </button>
          </FormListItem>
        )}

        <TitleElement title='技能士' name='worker_engineer_licenses' />
        <LicenseRegisterBlock
          valueArray={formValues.worker_engineer_licenses}
          keyObject={{
            searchKey: 'engineer_licenses_name',
            codeKey: 'engineer_licenses_code',
            targetKey: 'worker_engineer_licenses',
            takeDateKey: 'engineer_licenses_take_date',
            expireDateKey: 'engineer_licenses_expire_date',
          }}
          comboBoxObject={{
            isShow: true,
            comboBoxList: comboBoxList.workerEngineerLicenses,
            comboBoxTitle: '名称',
          }}
          takeDateObject={{
            isShow: true,
            takeDateTitle: '取得年月日',
          }}
          expireDateObject={{
            isShow: true,
            isShowInfo: true,
            expireDateTitle: '有効期限年月日',
          }}
          validPeriodObject={{
            isShow: true,
            validPeriodTitle: '有効期間',
          }}
          attachDocumentObject={{
            isShow: true,
            documentCodes: attachDocumentCodes_License,
            itemName: '',
            indexId: '技能士',
            labelDocument: '証明書・免許証',
            keyName: 'worker_engineer_licenses',
          }}
          messageArray={_.get(messages, 'jobLicense.worker_engineer_licenses')}
          disabled={disabledAll}
          safetyDocItem={true}
          events={events}
        />
        {!disabledAll && (
          <FormListItem className='form-list__item form-list__item--btn'>
            <button
              className='btn--sub'
              onClick={() => {
                events.addNewBlock('worker_engineer_licenses', {
                  id: null,
                  engineer_licenses_code: '0',
                  engineer_licenses_name: '',
                  engineer_licenses_take_date: null,
                  engineer_licenses_expire_date: null,
                  worker_documents: [],
                  validPeriodObject: {},
                  showExpireDate: true,
                  warningMessage: null,
                });
              }}
            >
              追加する
            </button>
          </FormListItem>
        )}

        <TitleElement title='免許資格' name='worker_licenses' />

        <LicenseRegisterBlock
          valueArray={formValues.worker_licenses}
          keyObject={{
            searchKey: 'licenses_name',
            codeKey: 'licenses_code',
            targetKey: 'worker_licenses',
            takeDateKey: 'licenses_take_date',
            expireDateKey: 'licenses_expire_date',
          }}
          comboBoxObject={{
            isShow: true,
            comboBoxList: comboBoxList.workerLicenses,
            comboBoxTitle: '名称',
          }}
          licenseNoObject={{
            isShow: true,
            propertyName: 'licenses_no',
            licenseNoTitle: '免許資格番号',
          }}
          takeDateObject={{
            isShow: true,
            takeDateTitle: '取得年月日',
          }}
          expireDateObject={{
            isShow: true,
            isShowInfo: true,
            expireDateTitle: '有効期限年月日',
          }}
          validPeriodObject={{
            isShow: true,
            validPeriodTitle: '有効期間',
          }}
          attachDocumentObject={{
            isShow: true,
            documentCodes: attachDocumentCodes_License,
            itemName: '',
            indexId: '免許資格',
            labelDocument: '証明書・免許証',
            keyName: 'worker_licenses',
          }}
          messageArray={_.get(messages, 'jobLicense.worker_licenses')}
          disabled={disabledAll}
          safetyDocItem={true}
          events={events}
        />
        {!disabledAll && (
          <FormListItem className='form-list__item form-list__item--btn'>
            <button
              className='btn--sub'
              onClick={() => {
                events.addNewBlock('worker_licenses', {
                  id: null,
                  licenses_code: '0',
                  licenses_name: '',
                  licenses_take_date: null,
                  licenses_expire_date: null,
                  worker_documents: [],
                  validPeriodObject: {},
                  showExpireDate: true,
                  warningMessage: null,
                });
              }}
            >
              追加する
            </button>
          </FormListItem>
        )}

        <TitleElement title='添付書類' />
        <div className='form-list-default__ExceptionalItems'>
          <Description type='primary'>
            <React.Fragment>
              2021年12月19日以降本項目への添付書類の新規登録が行えなくなりました。
              <br />
              現在は「基幹技能者」「技能士」「免許資格」ごとにファイルの添付が可能です。
              <br />
              すでに本項に登録済みのファイルについては、個別に添付しなおしてください。
              <br />
              本項目は将来的に廃止を予定しているため、早めにファイルの再添付をお願いいたします。
            </React.Fragment>
          </Description>
        </div>
        <FormListItem label='証明書・免許証'>
          <FormElement>
            <AttachDocument
              companyDocuments={attachDocuments_License}
              documentCodes={attachDocumentCodes_License}
              events={events}
              readOnly={disabledAll}
              deleteOnly={true}
              isFormListDefault={true}
            />
          </FormElement>
        </FormListItem>
      </FormList>
    </div>
  );
};

export default JobLicenseForm;



// WEBPACK FOOTER //
// ./src/components/worker/form/JobLicenseForm.jsx